import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap';

export default class DatedListItem extends Component {
    render() {
        return (
            <div>
     <Row>
                <Col xs="4">{this.props.yearStart} - {this.props.yearFinish || 'till now'}</Col>
                <Col xs="8" className="dated-list__heading">{this.props.position}</Col>
            </Row>
            <Row>
                <Col xs="4"></Col>
                <Col xs="8" className="dated-list__main"><p>{this.props.companyName}</p><p>{this.props.description}</p></Col>
            </Row>
            </div>
       
        )
    }
}
